import { call, put, takeEvery, getContext } from "redux-saga/effects";

import { signUpSuccess, signUpFailure } from "./actions";
import { signUpActionTypes } from "./actionTypes";
import { CONTEXT } from "@const/redux";
import { removeEmptyKeys } from "@helpers/common";

const registerWithEmailPasswordAsync = ({
  UsersService,
  email,
  password,
  username,
  referral,
  isAcceptedTermsAndPrivacy,
  isAdultConfirmation,
  trackingCode,
}) => {
  if (!UsersService) {
    console.log("Required services does not exist");
    return null;
  }

  const requestBody = removeEmptyKeys({
    email,
    password,
    username,
    referral,
    isAcceptedTermsAndPrivacy,
    isAdultConfirmation,
    trackingCode,
  });

  return UsersService.register(requestBody);
};

function* signUp({
  payload: {
    email,
    password,
    username,
    referral,
    isAcceptedTermsAndPrivacy,
    isAdultConfirmation,
    trackingCode,
  },
}) {
  try {
    const { UsersService } = yield getContext(CONTEXT.SERVICES);
    const { data } = yield call(registerWithEmailPasswordAsync, {
      UsersService,
      email,
      password,
      username,
      referral,
      isAcceptedTermsAndPrivacy,
      isAdultConfirmation,
      trackingCode,
    });
    yield put(signUpSuccess(data));
  } catch ({ error }) {
    yield put(signUpFailure(error));
  }
}

export default function* watchSignUp() {
  yield takeEvery(signUpActionTypes.request, signUp);
}
